// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"9eb7c9b9","94":"3054f1fb","203":"80dbcb30","224":"9eb7c9b9","241":"3054f1fb","267":"9eb7c9b9","508":"6b9d39c9","815":"9eb7c9b9","905":"cc471af4","997":"7011782e"}[chunkId] + ".chunk.css";
};